import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";
import { motion } from "framer-motion";

const FloatingPhoneButton = () => {
  const { language } = useLanguage();

  const phones = {
    en: { number: "8329303059", display: "(832) 930-3059" },
    es: { number: "8323567254", display: "(832) 356-7254" },
    vi: { number: "8329303059", display: "(832) 930-3059" }
  };

  const currentPhone = phones[language as keyof typeof phones] || phones.en;

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="fixed bottom-24 right-6 z-40"
    >
      <a href={`tel:${currentPhone.number}`} aria-label={`Call ${currentPhone.display}`}>
        <Button
          size="lg"
          className="h-16 w-16 rounded-full shadow-2xl bg-green-600 hover:bg-green-700 text-white group"
          aria-label={`Call ${currentPhone.display}`}
        >
          <Phone className="h-7 w-7 group-hover:scale-110 transition-transform" />
        </Button>
      </a>
    </motion.div>
  );
};

export default FloatingPhoneButton;